module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/double-check-7835e5d046060a83ac503bb35702241e.svg";